import axios from 'axios';
import BaseUrl from '../BaseData/BaseUrl';
import ApiAccessHash from '../BaseData/AccessHash'


export const apiCall = async (config, callback, error) => {
    let options = null;
    if (config.data !== undefined) {    
        options = {
            method: config.method,
            url: await BaseUrl() + config.url,
            data: config.data
        }
    } else {
        options = {
            method: config.method,
            url: await BaseUrl() + config.url
        }
    }
    if (config.Authorization) {
        if (config.headers !== undefined) {
            let options1 = {
                'Authorization': `Bearer ${await ApiAccessHash()}`
            }
            let options2 = config.headers;
            options.headers = Object.assign(options1, options2);
            console.log('Erroroption', options.headers);
        } else {
            let options1 = {
                'Authorization': `Bearer ${await ApiAccessHash()}`
            }
            options.headers = options1;
        }
    }
    else {
        options.headers = config.headers;
    }

    axios.interceptors.response.use(null, (err) => {
        if (err.response !== undefined && err.response.status === 401) {
            error("مجوز دسترسی به سایت باطل شده است  با پشتیبانی تماس بگیرید");
        }
        return Promise.reject(err);
    });

    await axios(options)
        .then(
            (response) => {
                if (response !== undefined &&
                    response.data !== undefined &&
                    response.data !== "" &&
                    response.data !== null &&
                    response.status === 200) {

                    if (response.data.ResultCode === 1) {
                        callback(response);
                    }
                    else {
                        error(response.data.Message);
                    }
                }
                else {
                    error("مشکلی پیش آمده");
                }
            }
        )
        .catch((err) => {
            if (err.response) {
                if (err.response.status === 404) {
                    error("صفحه یافت نشد");
                }
            }
            else if (!err.response) {
                console.log(err);
                error("سرور در دسترس نیست");
            }
            else if (err.request) {
                console.log(err.request);
            } else {
                //console.log('Error', err.message);
            }
            //console.log(err.config);
        });

}